import useLang from "../../../hooks/useLang";

const useSelectivity = ({
  handleValueSubmit,
  handleNext,
  frequency,
  type,
  side,
  handleBack,
  canUndo,
}) => {
  const lang = useLang();
  lang("captions.correct");
  return {
    okButtonAttribs: {
      caption: "OK",
      sub: lang("captions.correct"),
      onClick: () => {
        handleValueSubmit({
          type,
          side,
          f: frequency,
        });
      },
    },
    mistakeButtonAttribs: {
      caption: "/",
      sub: lang("captions.error"),
      onClick: () => {
        handleValueSubmit({
          type,
          side,
          f: frequency,
          mistake: "blue_slashes",
        });
      },
    },
    backButtonAttribs: {
      icon: "undo",
      onClick: () => {
        handleBack();
      },
    },
    showBackButton: canUndo,
  };
};

export default useSelectivity;
